<template>
  <div class="global-loader">
    <Vue3Lottie
      :animationData="newLoader"
      :height="200"
      :width="200"
      alt="global-loader"
    />
  </div>
</template>
<style scoped>
.global-loader {
  @apply tw-fixed tw-bg-neutral-0 tw-z-[999999];
  width: 100vw;
  height: 100vh;
  display: grid;
  place-items: center;
}
</style>
<script setup lang="ts">
import { Vue3Lottie } from 'vue3-lottie';

import newLoader from '../assets/new-loader.json';
</script>
